import { render, staticRenderFns } from "./ChoseClassify.vue?vue&type=template&id=aee3b05a&scoped=true&"
import script from "./ChoseClassify.vue?vue&type=script&lang=js&"
export * from "./ChoseClassify.vue?vue&type=script&lang=js&"
import style0 from "./ChoseClassify.vue?vue&type=style&index=0&id=aee3b05a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee3b05a",
  null
  
)

export default component.exports